var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1031_11697)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.9998 65.6666L74.3332 70L69.9998 74.3333L65.6665 70L69.9998 65.6666Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6665 70L39.6665 31L0.666504 70L39.6665 109L78.6665 70ZM76.6665 70L39.6665 33L2.6665 70L39.6665 107L76.6665 70Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.333 70L100.333 31L61.333 70L100.333 109L139.333 70ZM137.333 70L100.333 33L63.333 70L100.333 107L137.333 70Z",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1031_11697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.667,
    height: 138.667,
    fill: "white",
    transform: "translate(0.666504 0.666626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnLoading);
export default __webpack_public_path__ + "static/media/on-loading.a8adc2b396df88b6fe6580cd4baa6e72.svg";
export { ForwardRef as ReactComponent };